export default "__VITE_ASSET__6ded8f6e__"